import { DataTable } from '@app/components/data-table/data-table';
import { DataTableToolbar } from '@app/components/data-table/data-table-toolbar';
import { useDataTable } from '@app/components/data-table/hooks/use-data-table';
import { DataTableProps } from '@app/components/data-table/types/data-table';
import CreateProcessingForm from '@app/components/product-form/create-ppt-forms/create-processing-form';
import useSimpleDialog from '@app/hooks/use-simple-dialog';
import { ProcessingTypeList } from '@shared/api/types';
import { Button } from '@shared/components/ui/button';
import { useToast } from '@shared/components/ui/use-toast';
import { useGetProcessingTableColumns } from './processing-table-columns';

interface ProcessingTableProps extends DataTableProps<ProcessingTypeList[]> {
  includeCreateButton?: boolean;
}

export default function ProcessingTable({
  data,
  refetch,
  includeCreateButton = true,
  isLoading,
  isFetchedAfterMount,
  isPreviousData,
  status,
}: ProcessingTableProps) {
  const { toast } = useToast();

  const {
    showSimpleDialog: showCreateProcessingDialog,
    SimpleDialogComponent: CreateProcessingDialog,
    closeSimpleDialog: closeCreateProcessingDialog,
  } = useSimpleDialog();

  const { table } = useDataTable({
    data: data || [],
    columns: useGetProcessingTableColumns(),
    initialState: {
      columnVisibility: {
        uuid: false,
      },
    },
  });

  return (
    <>
      <DataTable
        table={table}
        className="bg-gray-00"
        isLoading={(!isFetchedAfterMount && isPreviousData) || isLoading}
        tableLoading={!data && status === 'loading'}
      >
        <DataTableToolbar table={table}>
          {includeCreateButton && (
            <Button size="sm" onClick={() => showCreateProcessingDialog()}>
              Create
            </Button>
          )}
        </DataTableToolbar>
      </DataTable>
      {CreateProcessingDialog({
        header: 'Add processing step',
        content: (
          <CreateProcessingForm
            onProcessingCreated={() => {
              closeCreateProcessingDialog();
              toast({
                title: 'Processing step created successfully',
                variant: 'success',
              });
              refetch && refetch();
            }}
          />
        ),
      })}
    </>
  );
}
